import { useTranslation } from 'react-i18next';
import { ArrowsClockwiseIcon } from '@phosphor-icons/react';
import type { TaskScopeTab } from '../../services/tasks.service';

interface TasksPageHeaderProps {
  totalCount: number;
  activeTab: TaskScopeTab;
  canViewAllTasks: boolean;
  onTabChange: (tab: TaskScopeTab) => void;
  onRefresh: () => void;
}

export const TasksPageHeader = ({
  totalCount,
  activeTab,
  canViewAllTasks,
  onTabChange,
  onRefresh,
}: TasksPageHeaderProps) => {
  const { t } = useTranslation();

  const tabClassName = (tab: TaskScopeTab) =>
    `px-6 py-3 text-sm font-medium border-b-2 transition ${
      activeTab === tab
        ? 'border-primary text-primary'
        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
    }`;

  return (
    <div className="flex flex-col gap-4 border-b border-gray-200 px-4 pt-6 sm:px-6">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <h1 className="text-xl font-semibold text-gray-900">{t('tasks.title')}</h1>
          <span className="text-sm text-gray-500">{t('tasks.count', { count: totalCount })}</span>
        </div>
        <button
          type="button"
          onClick={onRefresh}
          className="flex items-center gap-2 text-sm font-medium text-primary hover:opacity-80 transition"
        >
          <ArrowsClockwiseIcon size={18} weight="regular" />
          {t('tasks.refresh')}
        </button>
      </div>

      <div className="flex overflow-x-auto">
        <button type="button" className={tabClassName('mine')} onClick={() => onTabChange('mine')}>
          {t('tasks.tabs.mine')}
        </button>
        {canViewAllTasks && (
          <button type="button" className={tabClassName('all')} onClick={() => onTabChange('all')}>
            {t('tasks.tabs.all')}
          </button>
        )}
      </div>
    </div>
  );
};
